import React from "react"
import badge from "badges/superstar.svg"
import { BadgeImage } from "backpack/badges/styled"

const Superstar = props => <BadgeImage src={badge} {...props} />

export default Superstar
